export const homeData = [
  {
    label: '日期',
    sortable: true,
    value: '1,statDate'
  },
  //   {
  //     label: '优化师ID',
  //     width:120,
  //     value: '2,personId'
  //   },
  {
    label: '优化师名称',
    sortable: true,
    width: 140,
    value: '3,person'
  },
  {
    label: '渠道',
    sortable: true,
    width: 140,
    value: '38,channelName'
  },
  {
    label: '语言',
    width: 140,
    sortable: false,
    value: '1102,langName'
  },
  {
    label: '广告系列ID',
    sortable: true,
    width: 200,
    value: '43,campaignId'
  },
  {
    label: '广告系列名称',
    width: 500,
    sortable: true,
    tooltip: true,
    resizable: true,
    tooltipMaxWidth: 300,
    value: '4,advertiseSeries'
  },
  {
    label: '广告组ID',
    sortable: true,
    width: 200,
    value: '41,adSetId'
  },
  {
    label: '广告组名称',
    sortable: true,
    width: 200,
    value: '42,adSetName'
  },
  {
    label: '广告名称',
    sortable: true,
    width: 200,
    value: '40,adName'
  },
  {
    label: '广告ID',
    sortable: true,
    width: 200,
    value: '39,adId'
  },
  {
    label: '广告状态',
    value: '32,adsCamStatus',
    sortable: true,
    width: 120,
    slot: 'status'
  },
  {
    label: '投放金额',
    sortable: true,
    width: 120,
    value: '5,cost'
  },
  {
    label: '广告付费率 (纯新)',
    value: '59,payPercentNew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.payPercentNew
            ? (Number(params.row.payPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '广告付费率 (包含重归因)',
    value: '60,payPercentAll',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.payPercentAll
            ? (Number(params.row.payPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '用户数（染色人数）',
    sortable: true,
    width: 170,
    value: '28,conversionUserCount'
  },
  {
    label: '新注册',
    width: 120,
    value: '6,activation'
  },
  {
    label: '染色成本',
    width: 120,
    value: '7,colorationCost'
  },
  { label: '下单次数 (纯新)', value: '47,orderCountNew' },
  { label: '下单次数 (包含重归因)', value: '48,orderCountAll' },
  { label: '付费次数 (纯新)', value: '49,payCountNew' },
  { label: '付费次数 (包含重归因)', value: '50,payCountAll' },
  { label: '充值次数付费成本 (纯新)', value: '61,payCountCostNew' },
  { label: '充值次数付费成本 (包含重归因)', value: '62,payCountCostAll' },
  { label: '订阅人数 (纯新)', value: '51,subscribeUserCountNew' },
  { label: '订阅人数 (包含重归因)', value: '52,subscribeUserCountAll' },
  { label: '订阅率 (纯新)', value: '63,subscribePercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.subscribePercentNew
            ? (Number(params.row.subscribePercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
   },
  { label: '订阅率 (包含重归因)', value: '64,subscribePercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.subscribePercentAll
            ? (Number(params.row.subscribePercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    } },
  { label: '首日订阅金额 (纯新)', value: '53,firstDaySubscribeAmountNew' },
  {
    label: '首日订阅金额 (包含重归因)',
    value: '54,firstDaySubscribeAmountAll'
  },
  {
    label: '首日回本率',
    needCalc: true,
    width: 120,
    value: '8,firstROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROI
            ? (Number(params.row.firstROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日回本率',
    needCalc: true,
    width: 120,
    value: '9,thirdROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROI
            ? (Number(params.row.thirdROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '8日回本率',
    needCalc: true,
    width: 120,
    value: '10,eighthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROI
            ? (Number(params.row.eighthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '15日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '11,fifthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROI
            ? (Number(params.row.fifthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '30日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '12,thirtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyROI
            ? (Number(params.row.thirtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '60日回本率',
    needCalc: true,
    value: '13,sixtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyROI
            ? (Number(params.row.sixtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },

  { label: '广告投放类型', value: '44,advertiseTypeName' },
  { label: '独立付费用户数 (纯新)', value: '45,payUserCountNew' },
  { label: '独立付费用户数 (包含重归因)', value: '46,payUserCountAll' },
  
  
  {
    label: '支付成功率 (纯新)',
    value: '55,paySuccessPercentNew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessPercentNew
            ? (Number(params.row.paySuccessPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '支付成功率 (包含重归因)',
    value: '56,paySuccessPercentAll',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessPercentAll
            ? (Number(params.row.paySuccessPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  { label: '独立用户付费成本 (纯新)', value: '57,payUserCostNew' },
  { label: '独立用户付费成本 (包含重归因)', value: '58,payUserCostAll' },
  
  
  
  

  {
    label: '首日充值金额',
    value: '15,firstRecharge'
  },
  {
    label: '累计3日充值金额',
    width: 150,
    value: '16,thirdRecharge'
  },
  {
    label: '累计8日充值金额',
    width: 150,
    value: '17,eighthRecharge'
  },
  {
    label: '累计15日充值金额',
    width: 160,
    value: '18,fifthRecharge'
  },
  {
    label: '累计30日充值金额',
    width: 160,
    value: '19,thirtyRecharge'
  },
  {
    label: '累计60日充值金额',
    width: 160,
    value: '20,sixtyRecharge'
  },
  {
    label: '新增占比',
    value: '65,activationPercent',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationPercent
            ? (Number(params.row.activationPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '新增付费率',
    value: '66,activationPayPercent',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationPayPercent
            ? (Number(params.row.activationPayPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日增长倍数',
    value: '22,threeTimesGrowth'
  },
  {
    label: '8日增长倍数',
    value: '23,eightTimesGrowth'
  },
  {
    label: '15日增长倍数',
    value: '24,fifthTimesGrowth'
  },
  {
    label: '30日增长倍数',
    value: '25,thirtyTimesGrowth'
  },
  {
    label: '60日增长倍数',
    value: '26,sixtyTimesGrowth'
  }
]
